// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card-body-content-title_root__7eA9M"};